import React, { useState } from "react";
import T from "prop-types";
import { CANCELLATION_REASONS } from "MODULES/PurchaseOrders/constants";
import { cancel } from "MODULES/Lots/actions";
import { connect } from "react-redux";
import ConfirmAction from "../../../shared/components/ConfirmAction";

function CancelLot({ cancelled, close, open, cancelLot }) {
  if (cancelled) return null;
  const [cancellationReason, setCancellationReason] = useState(
    CANCELLATION_REASONS[0].value
  );

  const handleSelectChange = e => {
    setCancellationReason(e.target.value);
  };

  return (
    <ConfirmAction
      onConfirm={() => cancelLot(cancellationReason)}
      close={close}
      open={open}
      btnClass="btn-danger"
      btnText="Yes, Cancel Lot"
      cancelText="Do Not Cancel Lot"
      icon={<i className="fa fa-fw fa-ban" />}
    >
      <strong>Heads up!</strong>
      &nbsp; Are you sure you want to cancel this order?
      <div>
        <label className="control-label" htmlFor="cancellation_reason">
          Cancellation Reason
        </label>
        <select
          className="form-control"
          name="cancellation_reason"
          onChange={e => handleSelectChange(e)}
        >
          {CANCELLATION_REASONS.map(reason => (
            <option key={reason.value} value={reason.value}>
              {reason.text}
            </option>
          ))}
        </select>
      </div>
    </ConfirmAction>
  );
}

export default connect(undefined, dispatch => ({
  cancelLot: reason => dispatch(cancel(reason))
}))(CancelLot);

CancelLot.propTypes = {
  cancelLot: T.func.isRequired,
  cancelled: T.bool,
  close: T.func,
  open: T.bool.isRequired
};



// WEBPACK FOOTER //
// ./app/modules/Lots/Detail/CancelLot/CancelLot.jsx